// Must outlast the backend's own AI_PACKING_LIST_TIMEOUT_SECONDS=300 plus the S3 download.
export const PDF_EXTRACTION_TIMEOUT_MS = 360000;

export const PALLETS_SAVE_TIMEOUT_MS = 120000;
